'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCurrentThreadHistory = undefined;

var _getSelectedThreadId = require('../../selected-thread/selectors/getSelectedThreadId');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var _stubbedThreadId = require('../../threads/constants/stubbedThreadId');

var _fetchThreadHistory = require('./fetchThreadHistory');

var fetchCurrentThreadHistory = exports.fetchCurrentThreadHistory = function fetchCurrentThreadHistory() {
  return function (dispatch, getState) {
    var sessionId = (0, _getSessionId.getSessionId)(getState());
    var threadId = (0, _getSelectedThreadId.getSelectedThreadId)(getState());

    if (threadId === null || threadId === _stubbedThreadId.STUBBED_THREAD_ID) {
      return;
    }

    dispatch((0, _fetchThreadHistory.fetchThreadHistory)({
      threadId: threadId,
      sessionId: sessionId
    }));
  };
};